import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import config from '../../config';
import { types as sdkTypes, util as sdkUtil } from '../../util/sdkLoader';
import { formatMoney } from '../../util/currency';
import { stringifyDateToISO8601 } from '../../util/dates';
import { isTransactionsTransitionInvalidTransition, storableError } from '../../util/errors';
import {
  txIsEnquired,
  getReview1Transition,
  getReview2Transition,
  txIsInFirstReviewBy,
  TRANSITION_ACCEPT,
  TRANSITION_DECLINE,
  TRANSITION_RELEASE_FUNDS,
  TRANSITION_MAKE_CUSTOM_OFFER,
  TRANSITION_MAKE_CUSTOM_PRO_OFFER,
  TRANSITION_ACCEPT_CUSTOM_PRO_OFFER,
  TRANSITION_DECLINE_OFFER,
  TRANSITION_MAKE_PROJECT_BID_AFTER_ENQUIRY,
  TRANSITION_ENQUIRE,
  TRANSITION_JOB_DONE,
  TRANSITION_JOB_DONE_CUSTOMER,
  TRANSITION_JOB_DONE_RELEASE_FUNDS,
  TRANSITION_JOB_DONE_PRO,
  TRANSITION_JOB_ACCEPTED,
  TRANSITION_ACCEPT_CUSTOM_OFFER_INVOICE,
  TRANSITION_JOB_DONE_INVOICE,
  TRANSITION_ACCEPT_JOB_INVOICE,
  TRANSITION_JOB_DONE_ACCEPT_INVOICE,
} from '../../util/transaction';
import {
  projectTransitionPrivileged,
  transactionLineItems,
  markTxUnread,
  markTxRead,
  completePayoutTransaction,
  cancelPayoutTransaction,
  fetchOwnReview as fetchOwnReviewApi,
  acceptOfferInvoice as acceptOfferInvoiceApi,
  vatPreview as vatPreviewApi,
  downloadTransactionReceipt,
} from '../../util/api';
import { receiptFilename } from '../../util/receipts/eligibility';
import { withGateCode } from '../../util/vatGate';
import * as log from '../../util/log';
import {
  isBrowserOpenable,
  mimeTypeForFileName,
  isInlineRenderableMimeType,
} from '../../util/fileAttachments';
import { trackIntercomEvent } from '../../util/intercom';
import {
  updatedEntities,
  denormalisedEntities,
  denormalisedResponseEntities,
} from '../../util/data';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import {
  clearStagedAttachments,
  publicFileAttachmentsMaybe,
  SCOPE_TRANSACTION_PAGE,
  SCOPE_CUSTOM_OFFER,
  protectedFileAttachmentsParam,
} from '../../ducks/messageAttachments.duck';
import { offerAttachments } from '../../util/customOffer';
import { fetchSkillsAndTools } from '../../ducks/SkillsAndTools.duck';
import {
  fetchCurrentUserHasOrdersSuccess,
  fetchCurrentUserNotifications,
  fetchCurrentUser,
} from '../../ducks/user.duck';

const { UUID } = sdkTypes;

const MESSAGES_PAGE_SIZE = 100;
const CUSTOMER = 'customer';

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/TransactionPage/SET_INITIAL_VALUES';

export const FETCH_TRANSACTION_REQUEST = 'app/TransactionPage/FETCH_TRANSACTION_REQUEST';
export const FETCH_TRANSACTION_SUCCESS = 'app/TransactionPage/FETCH_TRANSACTION_SUCCESS';
export const FETCH_TRANSACTION_ERROR = 'app/TransactionPage/FETCH_TRANSACTION_ERROR';

export const FETCH_TRANSITIONS_REQUEST = 'app/TransactionPage/FETCH_TRANSITIONS_REQUEST';
export const FETCH_TRANSITIONS_SUCCESS = 'app/TransactionPage/FETCH_TRANSITIONS_SUCCESS';
export const FETCH_TRANSITIONS_ERROR = 'app/TransactionPage/FETCH_TRANSITIONS_ERROR';

export const ACCEPT_SALE_REQUEST = 'app/TransactionPage/ACCEPT_SALE_REQUEST';
export const ACCEPT_SALE_SUCCESS = 'app/TransactionPage/ACCEPT_SALE_SUCCESS';
export const ACCEPT_SALE_ERROR = 'app/TransactionPage/ACCEPT_SALE_ERROR';

export const DECLINE_SALE_REQUEST = 'app/TransactionPage/DECLINE_SALE_REQUEST';
export const DECLINE_SALE_SUCCESS = 'app/TransactionPage/DECLINE_SALE_SUCCESS';
export const DECLINE_SALE_ERROR = 'app/TransactionPage/DECLINE_SALE_ERROR';

export const FETCH_MESSAGES_REQUEST = 'app/TransactionPage/FETCH_MESSAGES_REQUEST';
export const FETCH_MESSAGES_SUCCESS = 'app/TransactionPage/FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_ERROR = 'app/TransactionPage/FETCH_MESSAGES_ERROR';

export const SEND_MESSAGE_REQUEST = 'app/TransactionPage/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'app/TransactionPage/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'app/TransactionPage/SEND_MESSAGE_ERROR';

export const DOWNLOAD_ATTACHMENT_REQUEST = 'app/TransactionPage/DOWNLOAD_ATTACHMENT_REQUEST';
export const DOWNLOAD_ATTACHMENT_SUCCESS = 'app/TransactionPage/DOWNLOAD_ATTACHMENT_SUCCESS';
export const DOWNLOAD_ATTACHMENT_ERROR = 'app/TransactionPage/DOWNLOAD_ATTACHMENT_ERROR';

export const DOWNLOAD_RECEIPT_REQUEST = 'app/TransactionPage/DOWNLOAD_RECEIPT_REQUEST';
export const DOWNLOAD_RECEIPT_SUCCESS = 'app/TransactionPage/DOWNLOAD_RECEIPT_SUCCESS';
export const DOWNLOAD_RECEIPT_ERROR = 'app/TransactionPage/DOWNLOAD_RECEIPT_ERROR';

export const FETCH_ATTACHMENT_PREVIEW_URL_REQUEST =
  'app/TransactionPage/FETCH_ATTACHMENT_PREVIEW_URL_REQUEST';
export const FETCH_ATTACHMENT_PREVIEW_URL_SUCCESS =
  'app/TransactionPage/FETCH_ATTACHMENT_PREVIEW_URL_SUCCESS';
export const FETCH_ATTACHMENT_PREVIEW_URL_ERROR =
  'app/TransactionPage/FETCH_ATTACHMENT_PREVIEW_URL_ERROR';

export const SEND_REVIEW_REQUEST = 'app/TransactionPage/SEND_REVIEW_REQUEST';
export const SEND_REVIEW_SUCCESS = 'app/TransactionPage/SEND_REVIEW_SUCCESS';
export const SEND_REVIEW_ERROR = 'app/TransactionPage/SEND_REVIEW_ERROR';

export const FETCH_OWN_REVIEW_REQUEST = 'app/TransactionPage/FETCH_OWN_REVIEW_REQUEST';
export const FETCH_OWN_REVIEW_SUCCESS = 'app/TransactionPage/FETCH_OWN_REVIEW_SUCCESS';
export const FETCH_OWN_REVIEW_ERROR = 'app/TransactionPage/FETCH_OWN_REVIEW_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/TransactionPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/TransactionPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/TransactionPage/FETCH_TIME_SLOTS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST = 'app/TransactionPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/TransactionPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/TransactionPage/FETCH_LINE_ITEMS_ERROR';

export const RELEASE_FUNDS_REQUEST = 'app/TransactionPage/RELEASE_FUNDS_REQUEST';
export const RELEASE_FUNDS_SUCCESS = 'app/TransactionPage/RELEASE_FUNDS_SUCCESS';
export const RELEASE_FUNDS_ERROR = 'app/TransactionPage/RELEASE_FUNDS_ERROR';

export const SEND_CUSTOM_OFFER_REQUEST = 'app/TransactionPage/SEND_CUSTOM_OFFER_REQUEST';
export const SEND_CUSTOM_OFFER_SUCCESS = 'app/TransactionPage/SEND_CUSTOM_OFFER_SUCCESS';
export const SEND_CUSTOM_OFFER_ERROR = 'app/TransactionPage/SEND_CUSTOM_OFFER_ERROR';

export const ACCEPT_CUSTOM_OFFER_REQUEST = 'app/TransactionPage/ACCEPT_CUSTOM_OFFER_REQUEST';
export const ACCEPT_CUSTOM_OFFER_SUCCESS = 'app/TransactionPage/ACCEPT_CUSTOM_OFFER_SUCCESS';
export const ACCEPT_CUSTOM_OFFER_ERROR = 'app/TransactionPage/ACCEPT_CUSTOM_OFFER_ERROR';

export const ACCEPT_CUSTOM_PRO_OFFER_REQUEST =
  'app/TransactionPage/ACCEPT_CUSTOM_PRO_OFFER_REQUEST';
export const ACCEPT_CUSTOM_PRO_OFFER_SUCCESS =
  'app/TransactionPage/ACCEPT_CUSTOM_PRO_OFFER_SUCCESS';
export const ACCEPT_CUSTOM_PRO_OFFER_ERROR = 'app/TransactionPage/ACCEPT_CUSTOM_PRO_OFFER_ERROR';

export const ACCEPT_OFFER_INVOICE_REQUEST = 'app/TransactionPage/ACCEPT_OFFER_INVOICE_REQUEST';
export const ACCEPT_OFFER_INVOICE_SUCCESS = 'app/TransactionPage/ACCEPT_OFFER_INVOICE_SUCCESS';
export const ACCEPT_OFFER_INVOICE_ERROR = 'app/TransactionPage/ACCEPT_OFFER_INVOICE_ERROR';

export const FETCH_VAT_PREVIEW_REQUEST = 'app/TransactionPage/FETCH_VAT_PREVIEW_REQUEST';
export const FETCH_VAT_PREVIEW_SUCCESS = 'app/TransactionPage/FETCH_VAT_PREVIEW_SUCCESS';
export const FETCH_VAT_PREVIEW_ERROR = 'app/TransactionPage/FETCH_VAT_PREVIEW_ERROR';

export const DECLINE_PROJECT_BID_REQUEST = 'app/TransactionPage/DECLINE_PROJECT_BID_REQUEST';
export const DECLINE_PROJECT_BID_SUCCESS = 'app/TransactionPage/DECLINE_PROJECT_BID_SUCCESS';
export const DECLINE_PROJECT_BID_ERROR = 'app/TransactionPage/DECLINE_PROJECT_BID_ERROR';

export const SEND_PROJECT_BID_REQUEST = 'app/TransactionPage/SEND_PROJECT_BID_REQUEST';
export const SEND_PROJECT_BID_SUCCESS = 'app/TransactionPage/SEND_PROJECT_BID_SUCCESS';
export const SEND_PROJECT_BID_ERROR = 'app/TransactionPage/SEND_PROJECT_BID_ERROR';

export const SHOW_PROFILE_LISTING_REQUEST = 'app/TransactionPage/SHOW_PROFILE_LISTING_REQUEST';
export const SHOW_PROFILE_LISTING_SUCCESS = 'app/TransactionPage/SHOW_PROFILE_LISTING_SUCCESS';
export const SHOW_PROFILE_LISTING_ERROR = 'app/TransactionPage/SHOW_PROFILE_LISTING_ERROR';

export const FETCH_PROJECT_TRANSACTION_REQUEST =
  'app/TransactionPage/FETCH_PROJECT_TRANSACTION_REQUEST';
export const FETCH_PROJECT_TRANSACTION_SUCCESS =
  'app/TransactionPage/FETCH_PROJECT_TRANSACTION_SUCCESS';
export const FETCH_PROJECT_TRANSACTION_ERROR =
  'app/TransactionPage/FETCH_PROJECT_TRANSACTION_ERROR';

export const SEND_ENQUIRY_REQUEST_LISTING = 'app/ListingPage/SEND_ENQUIRY_REQUEST';
export const SEND_ENQUIRY_SUCCESS_LISTING = 'app/ListingPage/SEND_ENQUIRY_SUCCESS';
export const SEND_ENQUIRY_ERROR_LISTING = 'app/ListingPage/SEND_ENQUIRY_ERROR';

export const SEND_ENQUIRY_REQUEST_PROJECT = 'app/ProjectListingPage/SEND_ENQUIRY_REQUEST';
export const SEND_ENQUIRY_SUCCESS_PROJECT = 'app/ProjectListingPage/SEND_ENQUIRY_SUCCESS';
export const SEND_ENQUIRY_ERROR_PROJECT = 'app/ProjectListingPage/SEND_ENQUIRY_ERROR';

export const CHECK_JOB_AS_COMPLETED_REQUEST = 'app/TransactionPage/MARK_JOB_DONE_REQUEST';
export const CHECK_JOB_AS_COMPLETED_SUCCESS = 'app/ListingPage/MARK_JOB_DONE_SUCCESS';
export const CHECK_JOB_AS_COMPLETED_ERROR = 'app/ListingPage/MARK_JOB_DONE_ERROR';

export const SEND_JOB_DONE_RELEASE_FUNDS_REQUEST =
  'app/TransactionPage/SEND_JOB_DONE_RELEASE_FUNDS_REQUEST';
export const SEND_JOB_DONE_RELEASE_FUNDS_SUCCESS =
  'app/TransactionPage/SEND_JOB_DONE_RELEASE_FUNDS_SUCCESS';
export const SEND_JOB_DONE_RELEASE_FUNDS_ERROR =
  'app/TransactionPage/SEND_JOB_DONE_RELEASE_FUNDS_ERROR';

export const FETCH_APPLICATION_TRANSACTION_REQUEST =
  'app/TransactionPage/FETCH_APPLICATION_TRANSACTION_REQUEST';
export const FETCH_APPLICATION_TRANSACTION_SUCCESS =
  'app/TransactionPage/FETCH_APPLICATION_TRANSACTION_SUCCESS';
export const FETCH_APPLICATION_TRANSACTION_ERROR =
  'app/TransactionPage/FETCH_APPLICATION_TRANSACTION_ERROR';

export const FETCH_APPLICATION_PORTFOLIO_WORKS_REQUEST =
  'app/TransactionPage/FETCH_APPLICATION_PORTFOLIO_WORKS_REQUEST';
export const FETCH_APPLICATION_PORTFOLIO_WORKS_SUCCESS =
  'app/TransactionPage/FETCH_APPLICATION_PORTFOLIO_WORKS_SUCCESS';
export const FETCH_APPLICATION_PORTFOLIO_WORKS_ERROR =
  'app/TransactionPage/FETCH_APPLICATION_PORTFOLIO_WORKS_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchTransactionInProgress: false,
  fetchTransactionError: null,
  transactionRef: null,
  acceptInProgress: false,
  acceptSaleError: null,
  declineInProgress: false,
  declineSaleError: null,
  fetchMessagesInProgress: false,
  fetchMessagesError: null,
  totalMessages: 0,
  totalMessagePages: 0,
  oldestMessagePageFetched: 0,
  messages: [],
  // Transaction (conversation) the messages in state currently belong to. Used to
  // discard out-of-order message responses from a previously viewed conversation.
  activeMessagesTxId: null,
  initialMessageFailedToTransaction: null,
  savePaymentMethodFailed: false,
  sendMessageInProgress: false,
  sendMessageError: null,
  downloadAttachmentInProgressIds: [],
  downloadAttachmentError: null,
  // Keyed by transaction id, so another conversation never shows this one's
  // spinner or error.
  downloadReceiptInProgressId: null,
  downloadReceiptFailedId: null,
  // Signed preview URLs for image attachments in the feed, keyed by
  // attachment id. Short-lived; an expired entry is force-refetched once.
  attachmentPreviewUrls: {},
  attachmentPreviewUrlPendingIds: [],
  sendReviewInProgress: false,
  sendReviewError: null,
  // The current user's own review while the transaction still waits for the
  // other party's review (double-blind phase): null | { content, rating, ... }
  ownReview: null,
  fetchOwnReviewError: null,
  timeSlots: null,
  fetchTimeSlotsError: null,
  fetchTransitionsInProgress: false,
  fetchTransitionsError: null,
  processTransitions: null,
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  releaseFundsInProgress: false,
  releaseFundsError: null,
  sendCustomOfferInProgress: false,
  sendCustomOfferError: null,
  acceptCustomOfferInProgress: false,
  acceptCustomOfferError: null,
  acceptCustomProOfferInProgress: false,
  acceptCustomProOfferError: null,
  acceptOfferInvoiceInProgress: false,
  acceptOfferInvoiceError: null,
  vatPreview: null,
  vatPreviewInProgress: false,
  vatPreviewError: null,
  vatPreviewSeq: 0,
  declineProjectBidInProgress: false,
  declineProjectBidError: null,
  sendProjectBidInProgress: false,
  sendProjectBidError: null,
  profileListing: null,
  showProfileListingInProgress: false,
  showProfileListingError: false,
  fetchProjectTransactionInProgress: false,
  fetchProjectTransactionError: null,
  projectTransactionRef: null,
  sendEnquiryInProgressListing: false,
  sendEnquiryErrorListing: null,
  sendEnquiryInProgressProject: false,
  sendEnquiryErrorProject: null,
  enquiryModalOpenForListingId: null,
  checkJobAsCompleted: false,
  jobDoneReleaseFundsInProgress: false,
  jobDoneReleaseFundsError: null,
  fetchApplicationTransactionInProgress: false,
  fetchApplicationTransactionError: null,
  applicationTransactionRef: null,
  applicationPortfolioWorks: [],
  fetchApplicationPortfolioWorksInProgress: false,
  fetchApplicationPortfolioWorksError: null,
};

// Merge entity arrays using ids, so that conflicting items in newer array (b) overwrite old values (a).
// const a = [{ id: { uuid: 1 } }, { id: { uuid: 3 } }];
// const b = [{ id: : { uuid: 2 } }, { id: : { uuid: 1 } }];
// mergeEntityArrays(a, b)
// => [{ id: { uuid: 3 } }, { id: : { uuid: 2 } }, { id: : { uuid: 1 } }]
const mergeEntityArrays = (a, b) => {
  return a.filter(aEntity => !b.find(bEntity => aEntity.id.uuid === bEntity.id.uuid)).concat(b);
};

export default function checkoutPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case FETCH_TRANSACTION_REQUEST:
      return { ...state, fetchTransactionInProgress: true, fetchTransactionError: null };
    case FETCH_TRANSACTION_SUCCESS: {
      const transactionRef = { id: payload.data.data.id, type: 'transaction' };
      return { ...state, fetchTransactionInProgress: false, transactionRef };
    }
    case FETCH_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransactionInProgress: false, fetchTransactionError: payload };

    case FETCH_TRANSITIONS_REQUEST:
      return { ...state, fetchTransitionsInProgress: true, fetchTransitionsError: null };
    case FETCH_TRANSITIONS_SUCCESS:
      return { ...state, fetchTransitionsInProgress: false, processTransitions: payload };
    case FETCH_TRANSITIONS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransitionsInProgress: false, fetchTransitionsError: payload };

    case ACCEPT_SALE_REQUEST:
      return { ...state, acceptInProgress: true, acceptSaleError: null, declineSaleError: null };
    case ACCEPT_SALE_SUCCESS:
      return { ...state, acceptInProgress: false };
    case ACCEPT_SALE_ERROR:
      return { ...state, acceptInProgress: false, acceptSaleError: payload };

    case DECLINE_SALE_REQUEST:
      return { ...state, declineInProgress: true, declineSaleError: null, acceptSaleError: null };
    case DECLINE_SALE_SUCCESS:
      return { ...state, declineInProgress: false };
    case DECLINE_SALE_ERROR:
      return { ...state, declineInProgress: false, declineSaleError: payload };

    case FETCH_MESSAGES_REQUEST:
      return { ...state, fetchMessagesInProgress: true, fetchMessagesError: null };
    case FETCH_MESSAGES_SUCCESS: {
      // Ignore responses that belong to a different (stale) transaction than the
      // one currently being viewed. Guards against out-of-order async responses
      // when navigating between conversations via in-app links (the store persists
      // and an in-flight fetch from the previous conversation can resolve late).
      if (state.activeMessagesTxId && payload.txId !== state.activeMessagesTxId) {
        return { ...state, fetchMessagesInProgress: false };
      }
      const oldestMessagePageFetched =
        state.oldestMessagePageFetched > payload.page
          ? state.oldestMessagePageFetched
          : payload.page;
      return {
        ...state,
        fetchMessagesInProgress: false,
        messages: mergeEntityArrays(state.messages, payload.messages),
        totalMessages: payload.totalItems,
        totalMessagePages: payload.totalPages,
        oldestMessagePageFetched,
      };
    }
    case FETCH_MESSAGES_ERROR:
      return { ...state, fetchMessagesInProgress: false, fetchMessagesError: payload };

    case SEND_MESSAGE_REQUEST:
      return {
        ...state,
        sendMessageInProgress: true,
        sendMessageError: null,
        initialMessageFailedToTransaction: null,
      };
    case SEND_MESSAGE_SUCCESS:
      // Sending is disabled while uploads are in flight or failed, so everything
      // staged was attached to the sent message and can be cleared.
      return { ...state, sendMessageInProgress: false };
    case SEND_MESSAGE_ERROR:
      return { ...state, sendMessageInProgress: false, sendMessageError: payload };

    case DOWNLOAD_ATTACHMENT_REQUEST:
      return {
        ...state,
        downloadAttachmentInProgressIds: [...state.downloadAttachmentInProgressIds, payload.id],
        downloadAttachmentError: null,
      };
    case DOWNLOAD_ATTACHMENT_SUCCESS:
      return {
        ...state,
        downloadAttachmentInProgressIds: state.downloadAttachmentInProgressIds.filter(
          id => id !== payload.id
        ),
      };
    case DOWNLOAD_ATTACHMENT_ERROR:
      return {
        ...state,
        downloadAttachmentInProgressIds: state.downloadAttachmentInProgressIds.filter(
          id => id !== payload.id
        ),
        downloadAttachmentError: payload.error,
      };

    case DOWNLOAD_RECEIPT_REQUEST:
      return { ...state, downloadReceiptInProgressId: payload.id, downloadReceiptFailedId: null };
    case DOWNLOAD_RECEIPT_SUCCESS:
      return { ...state, downloadReceiptInProgressId: null };
    case DOWNLOAD_RECEIPT_ERROR:
      return { ...state, downloadReceiptInProgressId: null, downloadReceiptFailedId: payload.id };

    case FETCH_ATTACHMENT_PREVIEW_URL_REQUEST: {
      // Drop any stale url for this id so an <img> never keeps rendering a
      // known-expired src while the refetch is in flight.
      const { [payload.id]: staleUrl, ...attachmentPreviewUrls } = state.attachmentPreviewUrls;
      return {
        ...state,
        attachmentPreviewUrls,
        attachmentPreviewUrlPendingIds: [...state.attachmentPreviewUrlPendingIds, payload.id],
      };
    }
    case FETCH_ATTACHMENT_PREVIEW_URL_SUCCESS:
      return {
        ...state,
        attachmentPreviewUrls: { ...state.attachmentPreviewUrls, [payload.id]: payload.url },
        attachmentPreviewUrlPendingIds: state.attachmentPreviewUrlPendingIds.filter(
          id => id !== payload.id
        ),
      };
    case FETCH_ATTACHMENT_PREVIEW_URL_ERROR:
      return {
        ...state,
        attachmentPreviewUrlPendingIds: state.attachmentPreviewUrlPendingIds.filter(
          id => id !== payload.id
        ),
      };

    case SEND_REVIEW_REQUEST:
      return { ...state, sendReviewInProgress: true, sendReviewError: null };
    case SEND_REVIEW_SUCCESS:
      return { ...state, sendReviewInProgress: false };
    case SEND_REVIEW_ERROR:
      return { ...state, sendReviewInProgress: false, sendReviewError: payload };

    case FETCH_OWN_REVIEW_REQUEST:
      return { ...state, fetchOwnReviewError: null };
    case FETCH_OWN_REVIEW_SUCCESS:
      return { ...state, ownReview: payload };
    case FETCH_OWN_REVIEW_ERROR:
      return { ...state, fetchOwnReviewError: payload };

    case FETCH_TIME_SLOTS_REQUEST:
      return { ...state, fetchTimeSlotsError: null };
    case FETCH_TIME_SLOTS_SUCCESS:
      return { ...state, timeSlots: payload };
    case FETCH_TIME_SLOTS_ERROR:
      return { ...state, fetchTimeSlotsError: payload };

    case FETCH_LINE_ITEMS_REQUEST:
      return { ...state, fetchLineItemsInProgress: true, fetchLineItemsError: null };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };

    case RELEASE_FUNDS_REQUEST:
      return { ...state, releaseFundsInProgress: true, releaseFundsError: null };
    case RELEASE_FUNDS_SUCCESS:
      return { ...state, releaseFundsInProgress: false };
    case RELEASE_FUNDS_ERROR:
      return { ...state, releaseFundsInProgress: false, releaseFundsError: payload };

    case SEND_CUSTOM_OFFER_REQUEST:
      return { ...state, sendCustomOfferInProgress: true, sendCustomOfferError: null };
    case SEND_CUSTOM_OFFER_SUCCESS:
      return { ...state, sendCustomOfferInProgress: false };
    case SEND_CUSTOM_OFFER_ERROR:
      return { ...state, sendCustomOfferInProgress: false, sendCustomOfferError: payload };

    case ACCEPT_CUSTOM_OFFER_REQUEST:
      return { ...state, acceptCustomOfferInProgress: true, acceptCustomOfferError: null };
    case ACCEPT_CUSTOM_OFFER_SUCCESS:
      return { ...state, acceptCustomOfferInProgress: false };
    case ACCEPT_CUSTOM_OFFER_ERROR:
      return { ...state, acceptCustomOfferInProgress: false, acceptCustomOfferError: payload };

    case ACCEPT_CUSTOM_PRO_OFFER_REQUEST:
      return { ...state, acceptCustomProOfferInProgress: true, acceptCustomProOfferError: null };
    case ACCEPT_CUSTOM_PRO_OFFER_SUCCESS:
      return { ...state, acceptCustomProOfferInProgress: false };
    case ACCEPT_CUSTOM_PRO_OFFER_ERROR:
      return {
        ...state,
        acceptCustomProOfferInProgress: false,
        acceptCustomProOfferError: payload,
      };

    case ACCEPT_OFFER_INVOICE_REQUEST:
      return { ...state, acceptOfferInvoiceInProgress: true, acceptOfferInvoiceError: null };
    case ACCEPT_OFFER_INVOICE_SUCCESS:
      return { ...state, acceptOfferInvoiceInProgress: false };
    case ACCEPT_OFFER_INVOICE_ERROR:
      return { ...state, acceptOfferInvoiceInProgress: false, acceptOfferInvoiceError: payload };

    case FETCH_VAT_PREVIEW_REQUEST:
      return {
        ...state,
        vatPreviewSeq: payload.seq,
        vatPreviewInProgress: true,
        vatPreviewError: null,
      };
    case FETCH_VAT_PREVIEW_SUCCESS:
      // A response for a payment method or fetch that is no longer the most
      // recent one (R41): a newer request is still in flight, so it must
      // keep vatPreviewInProgress true rather than being clobbered by this
      // stale response landing late.
      if (payload.seq !== state.vatPreviewSeq) return state;
      return { ...state, vatPreviewInProgress: false, vatPreview: payload.preview };
    case FETCH_VAT_PREVIEW_ERROR:
      if (payload.seq !== state.vatPreviewSeq) return state;
      return {
        ...state,
        vatPreviewInProgress: false,
        vatPreview: null,
        vatPreviewError: payload.error,
      };

    case DECLINE_PROJECT_BID_REQUEST:
      return { ...state, declineProjectBidInProgress: true, declineProjectBidError: null };
    case DECLINE_PROJECT_BID_SUCCESS:
      return { ...state, declineProjectBidInProgress: false };
    case DECLINE_PROJECT_BID_ERROR:
      return { ...state, declineProjectBidInProgress: false, declineProjectBidError: payload };

    case SEND_PROJECT_BID_REQUEST:
      return { ...state, sendProjectBidInProgress: true, sendProjectBidError: null };
    case SEND_PROJECT_BID_SUCCESS:
      return { ...state, sendProjectBidInProgress: false };
    case SEND_PROJECT_BID_ERROR:
      return { ...state, sendProjectBidInProgress: false, sendProjectBidError: payload };

    case SHOW_PROFILE_LISTING_REQUEST:
      return {
        ...state,
        showProfileListingInProgress: true,
        showProfileListingError: null,
        profileListing: null,
      };
    case SHOW_PROFILE_LISTING_SUCCESS:
      return { ...state, showProfileListingInProgress: false, profileListing: payload };
    case SHOW_PROFILE_LISTING_ERROR:
      return { ...state, showProfileListingInProgress: false, showProfileListingError: payload };

    case FETCH_PROJECT_TRANSACTION_REQUEST:
      return {
        ...state,
        fetchProjectTransactionInProgress: true,
        fetchProjectTransactionError: null,
      };
    case FETCH_PROJECT_TRANSACTION_SUCCESS: {
      const projectTransactionRef = { id: payload.data.data.id, type: 'transaction' };
      return { ...state, fetchProjectTransactionInProgress: false, projectTransactionRef };
    }
    case FETCH_PROJECT_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        fetchProjectTransactionInProgress: false,
        fetchProjectTransactionError: payload,
      };

    case SEND_ENQUIRY_REQUEST_LISTING:
      return { ...state, sendEnquiryInProgressListing: true, sendEnquiryErrorListing: null };
    case SEND_ENQUIRY_SUCCESS_LISTING:
      return { ...state, sendEnquiryInProgressListing: false };
    case SEND_ENQUIRY_ERROR_LISTING:
      return { ...state, sendEnquiryInProgressListing: false, sendEnquiryErrorListing: payload };

    case SEND_ENQUIRY_REQUEST_PROJECT:
      return { ...state, sendEnquiryInProgressProject: true, sendEnquiryErrorProject: null };
    case SEND_ENQUIRY_SUCCESS_PROJECT:
      return { ...state, sendEnquiryInProgressProject: false };
    case SEND_ENQUIRY_ERROR_PROJECT:
      return { ...state, sendEnquiryInProgressProject: false, sendEnquiryErrorProject: payload };

    case CHECK_JOB_AS_COMPLETED_SUCCESS:
      return { ...state, checkJobAsCompleted: true };

    case SEND_JOB_DONE_RELEASE_FUNDS_REQUEST:
      return { ...state, jobDoneReleaseFundsInProgress: true, jobDoneReleaseFundsError: null };
    case SEND_JOB_DONE_RELEASE_FUNDS_SUCCESS:
      return { ...state, jobDoneReleaseFundsInProgress: false, jobDoneReleaseFundsError: null };
    case SEND_JOB_DONE_RELEASE_FUNDS_ERROR:
      return { ...state, jobDoneReleaseFundsInProgress: false, jobDoneReleaseFundsError: payload };

    case FETCH_APPLICATION_TRANSACTION_REQUEST:
      return {
        ...state,
        fetchApplicationTransactionInProgress: true,
        fetchApplicationTransactionError: null,
      };
    case FETCH_APPLICATION_TRANSACTION_SUCCESS: {
      const applicationTransactionRef = { id: payload.data.data.id, type: 'transaction' };
      return { ...state, fetchApplicationTransactionInProgress: false, applicationTransactionRef };
    }
    case FETCH_APPLICATION_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        fetchApplicationTransactionInProgress: false,
        fetchApplicationTransactionError: payload,
      };

    case FETCH_APPLICATION_PORTFOLIO_WORKS_REQUEST:
      return {
        ...state,
        fetchApplicationPortfolioWorksInProgress: true,
        fetchApplicationPortfolioWorksError: null,
      };
    case FETCH_APPLICATION_PORTFOLIO_WORKS_SUCCESS:
      return {
        ...state,
        fetchApplicationPortfolioWorksInProgress: false,
        applicationPortfolioWorks: payload,
      };
    case FETCH_APPLICATION_PORTFOLIO_WORKS_ERROR:
      return {
        ...state,
        fetchApplicationPortfolioWorksInProgress: false,
        fetchApplicationPortfolioWorksError: payload,
      };

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const acceptOrDeclineInProgress = state => {
  return state.TransactionPage.acceptInProgress || state.TransactionPage.declineInProgress;
};

export const releaseFundsInProgress = state => {
  return state.TransactionPage.releaseFundsInProgress;
};

export const sendCustomOfferInProgress = state => {
  return state.TransactionPage.sendCustomOfferInProgress;
};

export const acceptCustomOfferInProgress = state => {
  return state.TransactionPage.acceptCustomOfferInProgress;
};

export const acceptCustomProOfferInProgress = state => {
  return state.TransactionPage.acceptCustomProOfferInProgress;
};

export const acceptOfferInvoiceInProgress = state => {
  return state.TransactionPage.acceptOfferInvoiceInProgress;
};

export const declineProjectBidInProgress = state => {
  return state.TransactionPage.declineProjectBidInProgress;
};

// ================ Selectors ================ //

// ================ Action creators ================ //
export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const fetchTransactionRequest = () => ({ type: FETCH_TRANSACTION_REQUEST });
const fetchTransactionSuccess = response => ({
  type: FETCH_TRANSACTION_SUCCESS,
  payload: response,
});
const fetchTransactionError = e => ({ type: FETCH_TRANSACTION_ERROR, error: true, payload: e });

const fetchTransitionsRequest = () => ({ type: FETCH_TRANSITIONS_REQUEST });
const fetchTransitionsSuccess = response => ({
  type: FETCH_TRANSITIONS_SUCCESS,
  payload: response,
});
const fetchTransitionsError = e => ({ type: FETCH_TRANSITIONS_ERROR, error: true, payload: e });

const acceptSaleRequest = () => ({ type: ACCEPT_SALE_REQUEST });
const acceptSaleSuccess = () => ({ type: ACCEPT_SALE_SUCCESS });
const acceptSaleError = e => ({ type: ACCEPT_SALE_ERROR, error: true, payload: e });

const declineSaleRequest = () => ({ type: DECLINE_SALE_REQUEST });
const declineSaleSuccess = () => ({ type: DECLINE_SALE_SUCCESS });
const declineSaleError = e => ({ type: DECLINE_SALE_ERROR, error: true, payload: e });

const fetchMessagesRequest = () => ({ type: FETCH_MESSAGES_REQUEST });
const fetchMessagesSuccess = (messages, pagination, txId) => ({
  type: FETCH_MESSAGES_SUCCESS,
  payload: { messages, txId, ...pagination },
});
const fetchMessagesError = e => ({ type: FETCH_MESSAGES_ERROR, error: true, payload: e });

const sendMessageRequest = () => ({ type: SEND_MESSAGE_REQUEST });
const sendMessageSuccess = () => ({ type: SEND_MESSAGE_SUCCESS });
const sendMessageError = e => ({ type: SEND_MESSAGE_ERROR, error: true, payload: e });

export const downloadAttachmentRequest = id => ({
  type: DOWNLOAD_ATTACHMENT_REQUEST,
  payload: { id },
});
export const downloadAttachmentSuccess = id => ({
  type: DOWNLOAD_ATTACHMENT_SUCCESS,
  payload: { id },
});
export const downloadAttachmentError = (id, error) => ({
  type: DOWNLOAD_ATTACHMENT_ERROR,
  payload: { id, error },
});

export const downloadReceiptRequest = id => ({ type: DOWNLOAD_RECEIPT_REQUEST, payload: { id } });
export const downloadReceiptSuccess = id => ({ type: DOWNLOAD_RECEIPT_SUCCESS, payload: { id } });
export const downloadReceiptError = id => ({ type: DOWNLOAD_RECEIPT_ERROR, payload: { id } });

export const fetchAttachmentPreviewUrlRequest = id => ({
  type: FETCH_ATTACHMENT_PREVIEW_URL_REQUEST,
  payload: { id },
});
export const fetchAttachmentPreviewUrlSuccess = (id, url) => ({
  type: FETCH_ATTACHMENT_PREVIEW_URL_SUCCESS,
  payload: { id, url },
});
export const fetchAttachmentPreviewUrlError = id => ({
  type: FETCH_ATTACHMENT_PREVIEW_URL_ERROR,
  payload: { id },
});

const sendReviewRequest = () => ({ type: SEND_REVIEW_REQUEST });
const sendReviewSuccess = () => ({ type: SEND_REVIEW_SUCCESS });
const sendReviewError = e => ({ type: SEND_REVIEW_ERROR, error: true, payload: e });

const fetchOwnReviewRequest = () => ({ type: FETCH_OWN_REVIEW_REQUEST });
export const fetchOwnReviewSuccess = review => ({
  type: FETCH_OWN_REVIEW_SUCCESS,
  payload: review,
});
const fetchOwnReviewError = e => ({ type: FETCH_OWN_REVIEW_ERROR, error: true, payload: e });

const fetchTimeSlotsRequest = () => ({ type: FETCH_TIME_SLOTS_REQUEST });
const fetchTimeSlotsSuccess = timeSlots => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: timeSlots,
});
const fetchTimeSlotsError = e => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: e,
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

const releaseFundsRequest = () => ({ type: RELEASE_FUNDS_REQUEST });
const releaseFundsSuccess = () => ({ type: RELEASE_FUNDS_SUCCESS });
const releaseFundsError = e => ({ type: RELEASE_FUNDS_ERROR, error: true, payload: e });

const sendCustomOfferRequest = () => ({ type: SEND_CUSTOM_OFFER_REQUEST });
const sendCustomOfferSuccess = () => ({ type: SEND_CUSTOM_OFFER_SUCCESS });
const sendCustomOfferError = e => ({ type: SEND_CUSTOM_OFFER_ERROR, error: true, payload: e });

const acceptCustomProOfferRequest = () => ({ type: ACCEPT_CUSTOM_OFFER_REQUEST });
const acceptCustomProOfferSuccess = () => ({ type: ACCEPT_CUSTOM_OFFER_SUCCESS });
const acceptCustomProOfferError = e => ({
  type: ACCEPT_CUSTOM_OFFER_ERROR,
  error: true,
  payload: e,
});

const acceptOfferInvoiceRequest = () => ({ type: ACCEPT_OFFER_INVOICE_REQUEST });
const acceptOfferInvoiceSuccess = () => ({ type: ACCEPT_OFFER_INVOICE_SUCCESS });
const acceptOfferInvoiceError = e => ({
  type: ACCEPT_OFFER_INVOICE_ERROR,
  error: true,
  payload: e,
});

const declineProjectBidRequest = () => ({ type: DECLINE_PROJECT_BID_REQUEST });
const declineProjectBidSuccess = () => ({ type: DECLINE_PROJECT_BID_SUCCESS });
const declineProjectBidError = e => ({ type: DECLINE_PROJECT_BID_ERROR, error: true, payload: e });

const sendProjectBidRequest = () => ({ type: SEND_PROJECT_BID_REQUEST });
const sendProjectBidSuccess = () => ({ type: SEND_PROJECT_BID_SUCCESS });
const sendProjectBidError = e => ({ type: SEND_PROJECT_BID_ERROR, error: true, payload: e });

const showProfileListingRequest = () => ({ type: SHOW_PROFILE_LISTING_REQUEST });
const showProfileListingSuccess = pl => ({ type: SHOW_PROFILE_LISTING_SUCCESS, payload: pl });
const showProfileListingError = e => ({
  type: SHOW_PROFILE_LISTING_ERROR,
  error: true,
  payload: e,
});

const fetchProjectTransactionRequest = () => ({ type: FETCH_PROJECT_TRANSACTION_REQUEST });
const fetchProjectTransactionSuccess = response => ({
  type: FETCH_PROJECT_TRANSACTION_SUCCESS,
  payload: response,
});
const fetchProjectTransactionError = e => ({
  type: FETCH_PROJECT_TRANSACTION_ERROR,
  error: true,
  payload: e,
});

export const sendEnquiryRequest = () => ({ type: SEND_ENQUIRY_REQUEST_LISTING });
export const sendEnquirySuccess = () => ({ type: SEND_ENQUIRY_SUCCESS_LISTING });
export const sendEnquiryError = e => ({
  type: SEND_ENQUIRY_ERROR_LISTING,
  error: true,
  payload: e,
});

export const checkJobAsCompletedRequest = () => ({ type: CHECK_JOB_AS_COMPLETED_REQUEST });
export const checkJobAsCompletedSuccess = () => ({ type: CHECK_JOB_AS_COMPLETED_SUCCESS });
export const checkJobAsCompletedError = e => ({
  type: CHECK_JOB_AS_COMPLETED_ERROR,
  error: true,
  payload: e,
});

export const jobDoneReleaseFundsRequest = () => ({ type: SEND_JOB_DONE_RELEASE_FUNDS_REQUEST });
export const jobDoneReleaseFundsSuccess = () => ({ type: SEND_JOB_DONE_RELEASE_FUNDS_SUCCESS });
export const jobDoneReleaseFundsError = e => ({
  type: SEND_JOB_DONE_RELEASE_FUNDS_ERROR,
  error: true,
  payload: e,
});

const fetchApplicationTransactionRequest = () => ({
  type: FETCH_APPLICATION_TRANSACTION_REQUEST,
});
const fetchApplicationTransactionSuccess = response => ({
  type: FETCH_APPLICATION_TRANSACTION_SUCCESS,
  payload: response,
});
const fetchApplicationTransactionError = e => ({
  type: FETCH_APPLICATION_TRANSACTION_ERROR,
  error: true,
  payload: e,
});

const fetchApplicationPortfolioWorksRequest = () => ({
  type: FETCH_APPLICATION_PORTFOLIO_WORKS_REQUEST,
});
const fetchApplicationPortfolioWorksSuccess = portfolioWorks => ({
  type: FETCH_APPLICATION_PORTFOLIO_WORKS_SUCCESS,
  payload: portfolioWorks,
});
const fetchApplicationPortfolioWorksError = e => ({
  type: FETCH_APPLICATION_PORTFOLIO_WORKS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

const listingRelationship = txResponse => {
  return txResponse.data.data.relationships.listing.data;
};

// Whether the current user is the party who already left their (still
// unpublished) review, i.e. the tx sits in reviewed-by-<own role> state.
export const userAwaitsOtherPartysReview = (transaction, currentUser) => {
  const currentUserId = currentUser?.id?.uuid;
  if (!currentUserId || !transaction) {
    return false;
  }
  const isCustomer = transaction.customer?.id?.uuid === currentUserId;
  const isProvider = transaction.provider?.id?.uuid === currentUserId;
  return (
    (isCustomer && txIsInFirstReviewBy(transaction, true)) ||
    (isProvider && txIsInFirstReviewBy(transaction, false))
  );
};

// The Marketplace API nulls pending review content even for the author, so
// the author's own review comes from our own API (Integration API behind it).
export const fetchOwnReview = txId => (dispatch, getState) => {
  if (getState().TransactionPage.ownReview) {
    return Promise.resolve();
  }
  dispatch(fetchOwnReviewRequest());
  return fetchOwnReviewApi(txId.uuid)
    .then(response => {
      dispatch(fetchOwnReviewSuccess(response.review));
    })
    .catch(e => {
      // Non-critical: the feed falls back to the text-only row.
      dispatch(fetchOwnReviewError(storableError(e)));
    });
};

export const fetchTransaction = (id, txRole) => (dispatch, getState, sdk) => {
  dispatch(fetchTransactionRequest());
  let txResponse = null;

  return sdk.transactions
    .show(
      {
        id,
        include: [
          'customer',
          'customer.profileImage',
          'provider',
          'provider.profileImage',
          'listing',
          'booking',
          'reviews',
          'reviews.author',
          'reviews.subject',
          'protectedFileAttachments',
          'protectedFileAttachments.file',
        ],
        ...IMAGE_VARIANTS,
      },
      { expand: true }
    )
    .then(response => {
      txResponse = response;
      const listingId = listingRelationship(response).id;
      const entities = updatedEntities({}, response.data);
      const listingRef = { id: listingId, type: 'listing' };
      const transactionRef = { id, type: 'transaction' };
      const denormalised = denormalisedEntities(entities, [listingRef, transactionRef]);
      const listing = denormalised[0];
      const transaction = denormalised[1];

      // Fetch time slots for transactions that are in enquired state
      const canFetchTimeslots =
        txRole === 'customer' &&
        config.enableAvailability &&
        transaction &&
        txIsEnquired(transaction);

      if (canFetchTimeslots) {
        dispatch(fetchTimeSlots(listingId));
      }

      if (
        transaction.attributes.protectedData &&
        transaction.attributes.protectedData.projectTransactionId
      ) {
        dispatch(
          fetchProjectTransaction(
            new UUID(transaction.attributes.protectedData.projectTransactionId)
          )
        );
      }

      // Fetch application transaction if this transaction was started from an application
      if (
        transaction.attributes.protectedData &&
        transaction.attributes.protectedData.applicationId
      ) {
        dispatch(
          fetchApplicationTransaction(new UUID(transaction.attributes.protectedData.applicationId))
        );
      }

      // Client-only: the SSR pass has no user session cookie for our own API.
      if (typeof window !== 'undefined') {
        const currentUser = getState().user.currentUser;
        if (userAwaitsOtherPartysReview(transaction, currentUser)) {
          dispatch(fetchOwnReview(id));
        }
      }

      const canFetchListing = listing && listing.attributes && !listing.attributes.deleted;
      if (canFetchListing) {
        return sdk.listings.show({
          id: listingId,
          include: ['author', 'author.profileImage', 'images'],
          ...IMAGE_VARIANTS,
        });
      } else {
        return response;
      }
    })
    .then(response => {
      dispatch(addMarketplaceEntities(txResponse));
      dispatch(addMarketplaceEntities(response));
      dispatch(fetchTransactionSuccess(txResponse));
      return response;
    })
    .catch(e => {
      dispatch(fetchTransactionError(storableError(e)));
      throw e;
    });
};

export const fetchProjectTransaction = id => (dispatch, getState, sdk) => {
  dispatch(fetchProjectTransactionRequest());
  let txResponse = null;

  return sdk.transactions
    .show(
      {
        id,
        include: [
          'customer',
          'customer.profileImage',
          'provider',
          'provider.profileImage',
          'listing',
          'booking',
          'reviews',
          'reviews.author',
          'reviews.subject',
        ],
        ...IMAGE_VARIANTS,
      },
      { expand: true }
    )
    .then(response => {
      txResponse = response;
      const listingId = listingRelationship(response).id;
      const entities = updatedEntities({}, response.data);
      const listingRef = { id: listingId, type: 'listing' };
      const transactionRef = { id, type: 'transaction' };
      const denormalised = denormalisedEntities(entities, [listingRef, transactionRef]);
      const listing = denormalised[0];

      const canFetchListing = listing && listing.attributes && !listing.attributes.deleted;
      if (canFetchListing) {
        return sdk.listings.show({
          id: listingId,
          include: ['author', 'author.profileImage', 'images'],
          ...IMAGE_VARIANTS,
        });
      } else {
        return response;
      }
    })
    .then(response => {
      dispatch(addMarketplaceEntities(txResponse));
      dispatch(addMarketplaceEntities(response));
      dispatch(fetchProjectTransactionSuccess(txResponse));
      return response;
    })
    .catch(e => {
      dispatch(fetchProjectTransactionError(storableError(e)));
      throw e;
    });
};

export const fetchApplicationTransaction = id => (dispatch, getState, sdk) => {
  dispatch(fetchApplicationTransactionRequest());
  let txResponse = null;

  return sdk.transactions
    .show(
      {
        id,
        include: [
          'customer',
          'customer.profileImage',
          'provider',
          'provider.profileImage',
          'listing',
        ],
        ...IMAGE_VARIANTS,
      },
      { expand: true }
    )
    .then(response => {
      txResponse = response;
      const listingId = listingRelationship(response).id;
      const entities = updatedEntities({}, response.data);
      const listingRef = { id: listingId, type: 'listing' };
      const transactionRef = { id, type: 'transaction' };
      const denormalised = denormalisedEntities(entities, [listingRef, transactionRef]);
      const listing = denormalised[0];

      const canFetchListing = listing && listing.attributes && !listing.attributes.deleted;
      if (canFetchListing) {
        return sdk.listings.show({
          id: listingId,
          include: ['author', 'author.profileImage', 'images'],
          ...IMAGE_VARIANTS,
        });
      } else {
        return response;
      }
    })
    .then(response => {
      dispatch(addMarketplaceEntities(txResponse));
      dispatch(addMarketplaceEntities(response));
      dispatch(fetchApplicationTransactionSuccess(txResponse));

      // Fetch portfolio works if they exist in transaction protectedData
      const transaction = txResponse.data.data;
      if (transaction && transaction.attributes && transaction.attributes.protectedData) {
        const { portfolioWorks = [] } = transaction.attributes.protectedData;
        if (portfolioWorks.length > 0) {
          dispatch(fetchApplicationPortfolioWorks(portfolioWorks));
        }
      }

      return response;
    })
    .catch(e => {
      dispatch(fetchApplicationTransactionError(storableError(e)));
      throw e;
    });
};

export const fetchApplicationPortfolioWorks = portfolioWorksData => (dispatch, getState, sdk) => {
  if (!portfolioWorksData || portfolioWorksData.length === 0) {
    return Promise.resolve([]);
  }

  dispatch(fetchApplicationPortfolioWorksRequest());

  // Extract IDs from portfolioWorks array
  const portfolioWorkIds = portfolioWorksData.map(work => work.id).filter(Boolean);

  if (portfolioWorkIds.length === 0) {
    dispatch(fetchApplicationPortfolioWorksSuccess([]));
    return Promise.resolve([]);
  }

  // Query listings by IDs
  const listingPromises = portfolioWorkIds.map(id => {
    return sdk.listings
      .show({
        id: new UUID(id),
        include: ['author', 'author.profileImage', 'images'],
        'fields.image': [
          'variants.horizontal',
          'variants.horizontal-2x',
          'variants.landscape-crop',
          'variants.landscape-crop2x',
          'variants.vertical',
          'variants.vertical-2x',
          'variants.square',
          'variants.square2x',
          'variants.square-small',
          'variants.square-small2x',
        ],
        'imageVariant.horizontal': sdkUtil.objectQueryString({
          w: 1920,
          h: 1080,
          fit: 'scale',
        }),
        'imageVariant.horizontal-2x': sdkUtil.objectQueryString({
          w: 2560,
          h: 1440,
          fit: 'scale',
        }),
        'imageVariant.vertical': sdkUtil.objectQueryString({
          w: 1080,
          h: 1920,
          fit: 'scale',
        }),
        'imageVariant.vertical-2x': sdkUtil.objectQueryString({
          w: 1440,
          h: 2560,
          fit: 'scale',
        }),
        'imageVariant.square': sdkUtil.objectQueryString({
          w: 1080,
          h: 1080,
          fit: 'scale',
        }),
        'imageVariant.square2x': sdkUtil.objectQueryString({
          w: 1440,
          h: 1440,
          fit: 'scale',
        }),
      })
      .then(response => response)
      .catch(() => null); // Return null for deleted/unavailable listings
  });

  return Promise.all(listingPromises)
    .then(results => {
      // First, add all entities to Redux store so images are available
      results.forEach(response => {
        if (response) {
          dispatch(addMarketplaceEntities(response));
        }
      });

      // Filter out null results and closed/deleted listings
      const activeWorks = results
        .filter(
          response =>
            response &&
            response.data &&
            response.data.data &&
            response.data.data.attributes.state !== 'closed' &&
            !response.data.data.attributes.deleted
        )
        .map(response => {
          const listing = response.data.data;
          const originalWork = portfolioWorksData.find(w => w.id === listing.id.uuid);

          // Get the image IDs that belong to this listing
          const listingImageIds =
            listing.relationships?.images?.data?.map(img => img.id.uuid) || [];

          // Filter images to only include those that belong to this listing
          const images =
            response.data.included?.filter(
              entity => entity.type === 'image' && listingImageIds.includes(entity.id.uuid)
            ) || [];

          return {
            id: listing.id,
            title: listing.attributes.title,
            slug: originalWork?.slug || '',
            images: images,
            attributes: listing.attributes,
          };
        });

      dispatch(fetchApplicationPortfolioWorksSuccess(activeWorks));
      return activeWorks;
    })
    .catch(e => {
      dispatch(fetchApplicationPortfolioWorksError(storableError(e)));
      return [];
    });
};

export const acceptSale = id => (dispatch, getState, sdk) => {
  if (acceptOrDeclineInProgress(getState())) {
    return Promise.reject(new Error('Accept or decline already in progress'));
  }
  dispatch(acceptSaleRequest());

  return sdk.transactions
    .transition(
      { id, transition: TRANSITION_ACCEPT, params: {} },
      { expand: true, include: ['customer', 'listing'] }
    )
    .then(response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const customer = transaction.relationships.customer.data;
      const { protectedData = {} } = transaction.attributes;
      const { lePayoutTransactionId } = protectedData;

      // Send the message to the created transaction
      return markTxUnread({
        transactionId: transactionId.uuid,
        recipientId: customer.id.uuid,
      }).then(() => {
        dispatch(addMarketplaceEntities(response));
        dispatch(acceptSaleSuccess());
        dispatch(fetchCurrentUserNotifications());

        if (lePayoutTransactionId) {
          return completePayoutTransaction(lePayoutTransactionId).then(() => {
            return response;
          });
        }

        return response;
      });
    })
    .catch(e => {
      dispatch(acceptSaleError(storableError(e)));
      log.error(e, 'accept-sale-failed', {
        txId: id,
        transition: TRANSITION_ACCEPT,
      });
      throw e;
    });
};

export const jobReady = id => async (dispatch, getState, sdk) => {
  dispatch(checkJobAsCompletedRequest());

  return sdk.transactions
    .transition(
      { id, transition: TRANSITION_JOB_DONE, params: {} },
      { expand: true, include: ['customer', 'listing'] }
    )
    .then(async response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const customer = transaction.relationships.customer.data;
      const { protectedData = {} } = transaction.attributes;
      const { lePayoutTransactionId } = protectedData;

      // Send the message to the created transaction
      await markTxUnread({
        transactionId: transactionId.uuid,
        recipientId: customer.id.uuid,
      });
      dispatch(addMarketplaceEntities(response));
      dispatch(checkJobAsCompletedSuccess());
      dispatch(fetchCurrentUserNotifications());
      if (lePayoutTransactionId) {
        return completePayoutTransaction(lePayoutTransactionId).then(() => {
          return response;
        });
      }
      return response;
    })
    .catch(e => {
      dispatch(checkJobAsCompletedError(storableError(e)));
      log.error(e, 'job-done-failed', {
        txId: id,
        transition: TRANSITION_JOB_DONE,
      });
      throw e;
    });
};

export const jobReadyCustomer = id => async (dispatch, getState, sdk) => {
  dispatch(checkJobAsCompletedRequest());

  return sdk.transactions
    .transition(
      { id, transition: TRANSITION_JOB_DONE_CUSTOMER, params: {} },
      { expand: true, include: ['provider', 'listing'] }
    )
    .then(async response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const provider = transaction.relationships.provider.data;
      const { protectedData = {} } = transaction.attributes;
      const { lePayoutTransactionId } = protectedData;

      // Send the message to the created transaction
      await markTxUnread({
        transactionId: transactionId.uuid,
        recipientId: provider.id.uuid,
      });
      dispatch(addMarketplaceEntities(response));
      dispatch(checkJobAsCompletedSuccess());
      dispatch(fetchCurrentUserNotifications());
      if (lePayoutTransactionId) {
        return completePayoutTransaction(lePayoutTransactionId).then(() => {
          return response;
        });
      }
      return response;
    })
    .catch(e => {
      dispatch(checkJobAsCompletedError(storableError(e)));
      log.error(e, 'job-done-failed', {
        txId: id,
        transition: TRANSITION_JOB_DONE_CUSTOMER,
      });
      throw e;
    });
};

export const jobReadyPro = id => async (dispatch, getState, sdk) => {
  dispatch(checkJobAsCompletedRequest());

  return sdk.transactions
    .transition(
      { id, transition: TRANSITION_JOB_DONE_PRO, params: {} },
      { expand: true, include: ['customer', 'listing'] }
    )
    .then(async response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const customer = transaction.relationships.customer.data;

      // Send the message to the created transaction
      await markTxUnread({
        transactionId: transactionId.uuid,
        recipientId: customer.id.uuid,
      });
      dispatch(addMarketplaceEntities(response));
      dispatch(checkJobAsCompletedSuccess());
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      dispatch(checkJobAsCompletedError(storableError(e)));
      log.error(e, 'job-done-failed', {
        txId: id,
        transition: TRANSITION_JOB_DONE_PRO,
      });
      throw e;
    });
};

export const acceptProJob = id => async (dispatch, getState, sdk) => {
  dispatch(checkJobAsCompletedRequest());

  return sdk.transactions
    .transition(
      { id, transition: TRANSITION_JOB_ACCEPTED, params: {} },
      { expand: true, include: ['provider', 'listing'] }
    )
    .then(async response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const provider = transaction.relationships.provider.data;

      // Send the message to the created transaction
      await markTxUnread({
        transactionId: transactionId.uuid,
        recipientId: provider.id.uuid,
      });
      dispatch(addMarketplaceEntities(response));
      dispatch(checkJobAsCompletedSuccess());
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      dispatch(checkJobAsCompletedError(storableError(e)));
      log.error(e, 'job-done-failed', {
        txId: id,
        transition: TRANSITION_JOB_ACCEPTED,
      });
      throw e;
    });
};

export const declineSale = id => (dispatch, getState, sdk) => {
  if (acceptOrDeclineInProgress(getState())) {
    return Promise.reject(new Error('Accept or decline already in progress'));
  }
  dispatch(declineSaleRequest());

  return sdk.transactions
    .transition(
      { id, transition: TRANSITION_DECLINE, params: {} },
      { expand: true, include: ['customer'] }
    )
    .then(response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const customer = transaction.relationships.customer.data;
      const { protectedData = {} } = transaction.attributes;
      const { lePayoutTransactionId } = protectedData;

      // Send the message to the created transaction
      return markTxUnread({
        transactionId: transactionId.uuid,
        recipientId: customer.id.uuid,
      }).then(() => {
        dispatch(addMarketplaceEntities(response));
        dispatch(declineSaleSuccess());
        dispatch(fetchCurrentUserNotifications());

        if (lePayoutTransactionId) {
          return cancelPayoutTransaction(lePayoutTransactionId).then(() => {
            return response;
          });
        }

        return response;
      });
    })
    .catch(e => {
      dispatch(declineSaleError(storableError(e)));
      log.error(e, 'reject-sale-failed', {
        txId: id,
        transition: TRANSITION_DECLINE,
      });
      throw e;
    });
};

export const releaseFunds = id => (dispatch, getState, sdk) => {
  if (releaseFundsInProgress(getState())) {
    return Promise.reject(new Error('Release funds already in progress'));
  }
  dispatch(releaseFundsRequest());

  const payoutInvoiceDate = new Date();

  return sdk.transactions
    .transition(
      {
        id,
        transition: TRANSITION_RELEASE_FUNDS,
        params: {
          protectedData: {
            payoutInvoiceDate: {
              year: payoutInvoiceDate.getFullYear(),
              month: payoutInvoiceDate.getMonth() + 1,
              day: payoutInvoiceDate.getDate(),
              hours: 0,
              minutes: 0,
              seconds: 0,
              milliseconds: 0,
            },
          },
        },
      },
      { expand: true, include: ['provider', 'customer', 'listing'] }
    )
    .then(response => {
      const tx = response.data.data;
      const { protectedData = {} } = tx.attributes;
      const { lePayoutTransactionId } = protectedData;

      dispatch(addMarketplaceEntities(response));
      dispatch(releaseFundsSuccess());
      dispatch(fetchCurrentUserNotifications());

      if (lePayoutTransactionId) {
        return sdk.transactions
          .transition(
            {
              id: new UUID(lePayoutTransactionId),
              transition: TRANSITION_RELEASE_FUNDS,
              params: {},
            },
            { expand: true }
          )
          .then(() => {
            return response;
          });
      }

      return response;
    })
    .then(response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const provider = transaction.relationships.provider.data;

      // Send the message to the created transaction
      return markTxUnread({
        transactionId: transactionId.uuid,
        recipientId: provider.id.uuid,
      }).then(() => {
        return response;
      });
    })
    .then(response => {
      if (typeof window === 'object') {
        trackIntercomEvent('Funds released', {
          transactionId: response.data.data.id.uuid,
          processName: response.data.data.attributes.processName,
          providerId: response.data.data.relationships.provider.data.id.uuid,
          customerId: response.data.data.relationships.customer.data.id.uuid,
          transition: 'TRANSITION_RELEASE_FUNDS',
          listingType: response.data.data.attributes.protectedData.projectTransactionId
            ? 'project'
            : 'service',
          listingId: response.data.data.relationships.listing.data.id.uuid,
        });
      }
      return response;
    })
    .catch(e => {
      dispatch(releaseFundsError(storableError(e)));
      log.error(e, 'release-funds-failed', {
        txId: id,
        transition: TRANSITION_RELEASE_FUNDS,
      });
      throw e;
    });
};

// `offer` is the CustomOfferForm submission plus the process flag:
// { title, description, customOfferAmount (Money), startDate ({ date }),
//   deliveryDate ({ date }), isProProcess, fileIds }. `fileIds` is undefined on
// a process version without :action/update-protected-files, otherwise the
// complete file set for the offer (an empty array detaches everything).
export const sendCustomOffer = (id, offer, intl) => (dispatch, getState, sdk) => {
  const {
    title,
    description,
    customOfferAmount,
    startDate,
    deliveryDate,
    isProProcess,
    fileIds,
  } = offer;
  if (sendCustomOfferInProgress(getState())) {
    return Promise.reject(new Error('Send custom offer is already in progress'));
  }
  dispatch(sendCustomOfferRequest());

  const attachmentsMaybe = Array.isArray(fileIds) ? protectedFileAttachmentsParam(fileIds) : {};

  return sdk.transactions
    .transition(
      {
        id,
        transition: isProProcess ? TRANSITION_MAKE_CUSTOM_PRO_OFFER : TRANSITION_MAKE_CUSTOM_OFFER,
        params: {
          protectedData: {
            customOfferTitle: title,
            customOfferDescription: description,
            customOfferAmount: customOfferAmount.amount,
            customOfferFormattedAmount: formatMoney(intl, customOfferAmount),
            customOfferStartDate: stringifyDateToISO8601(startDate.date),
            customOfferDeliveryDate: stringifyDateToISO8601(deliveryDate.date),
          },
          ...attachmentsMaybe,
        },
      },
      {
        expand: true,
        include: [
          'provider',
          'customer',
          'listing',
          'protectedFileAttachments',
          'protectedFileAttachments.file',
        ],
      }
    )
    .then(response => {
      const processName = response.data.data.attributes.processName;
      const processVersion = response.data.data.attributes.processVersion;
      const isStaging =
        process.env.REACT_APP_FINNISH_ROOT_URL === 'https://freedomly-staging.freedomly.io';

      // Determine if we should skip sending the custom offer message based on process version
      let shouldSkipMessage = false;
      if (processName === 'flex-default-process') {
        const minVersion = isStaging ? 81 : 33;
        shouldSkipMessage = processVersion >= minVersion;
      } else if (processName === 'flex-light-process') {
        const minVersion = isStaging ? 36 : 19;
        shouldSkipMessage = processVersion >= minVersion;
      } else if (processName === 'flex-pro-process') {
        const minVersion = isStaging ? 11 : 3;
        shouldSkipMessage = processVersion >= minVersion;
      }

      // The customer's notification text: posted as a chat message on older
      // process versions, otherwise carried by the unread marker.
      const customOfferMessage = intl.formatMessage(
        { id: 'TransactionPage.customOfferMessage' },
        {
          customOfferTitle: title,
          customOfferAmount: formatMoney(intl, customOfferAmount),
          customOfferDescription: description,
          customOfferStartDate: intl.formatDate(startDate.date),
          customOfferDeliveryDate: intl.formatDate(deliveryDate.date),
        }
      );

      if (!shouldSkipMessage) {
        dispatch(sendMessage(id, customOfferMessage));
      } else {
        const transaction = response.data.data;
        markTxUnread({
          transactionId: transaction.id.uuid,
          recipientId: transaction.relationships.customer.data.id.uuid,
          message: customOfferMessage,
        });
      }

      dispatch(addMarketplaceEntities(response));
      dispatch(sendCustomOfferSuccess());
      // The files are on the transaction now; the composer starts empty next time.
      dispatch(clearStagedAttachments(SCOPE_CUSTOM_OFFER));
      if (Array.isArray(fileIds) && fileIds.length > 0) {
        // Fire and forget: resolve "scanning" cards in the offer modal without a reload.
        dispatch(pollForOfferAttachmentScan(id, 'provider'));
      }
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .then(response => {
      if (typeof window === 'object') {
        trackIntercomEvent('New custom offer', {
          transactionId: response.data.data.id.uuid,
          processName: response.data.data.attributes.processName,
          providerId: response.data.data.relationships.provider.data.id.uuid,
          customerId: response.data.data.relationships.customer.data.id.uuid,
          transition: 'TRANSITION_MAKE_CUSTOM_OFFER',
          listingType: 'service',
          listingId: response.data.data.relationships.listing.data.id.uuid,
        });
      }
      return response;
    })
    .catch(e => {
      dispatch(sendCustomOfferError(storableError(e)));
      log.error(e, 'make-custom-offer-failed', {
        txId: id,
        transition: TRANSITION_ACCEPT,
      });
      throw e;
    });
};

export const acceptCustomProOffer = (id, description, customOfferAmount, intl) => (
  dispatch,
  getState,
  sdk
) => {
  if (acceptCustomProOfferInProgress(getState())) {
    return Promise.reject(new Error('Send custom offer is already in progress'));
  }
  dispatch(acceptCustomProOfferRequest());

  return sdk.transactions
    .transition(
      {
        id,
        transition: TRANSITION_ACCEPT_CUSTOM_PRO_OFFER,
        params: {},
      },
      { expand: true, include: ['provider', 'customer', 'listing'] }
    )
    .then(response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const provider = transaction.relationships.provider.data;

      // Send the message to the created transaction
      markTxUnread({
        transactionId: transactionId.uuid,
        recipientId: provider.id.uuid,
      });
      dispatch(addMarketplaceEntities(response));
      dispatch(acceptCustomProOfferSuccess());
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .then(response => {
      if (typeof window === 'object') {
        trackIntercomEvent('Custom Pro offer accepted', {
          transactionId: response.data.data.id.uuid,
          processName: response.data.data.attributes.processName,
          providerId: response.data.data.relationships.provider.data.id.uuid,
          customerId: response.data.data.relationships.customer.data.id.uuid,
          transition: 'TRANSITION_ACCEPT_CUSTOM_PRO_OFFER',
          listingType: 'service',
          listingId: response.data.data.relationships.listing.data.id.uuid,
        });
      }
      return response;
    })
    .catch(e => {
      dispatch(acceptCustomProOfferError(storableError(e)));
      log.error(e, 'accept-custom-offer-failed', {
        txId: id,
        transition: TRANSITION_ACCEPT,
      });
      throw e;
    });
};

// Customer accepts a pending custom offer by invoice. Privileged: the server
// derives price, booking and billing snapshot itself (server/api/accept-offer-invoice.js).
export const acceptOfferInvoice = id => (dispatch, getState, sdk) => {
  if (acceptOfferInvoiceInProgress(getState())) {
    return Promise.reject(new Error('Accept offer by invoice already in progress'));
  }
  dispatch(acceptOfferInvoiceRequest());

  return acceptOfferInvoiceApi({ transactionId: id.uuid })
    .then(response => {
      const transaction = response.data.data;
      const provider = transaction.relationships.provider.data;
      dispatch(addMarketplaceEntities(response));
      dispatch(acceptOfferInvoiceSuccess());
      dispatch(fetchCurrentUserNotifications());
      return markTxUnread({
        transactionId: transaction.id.uuid,
        recipientId: provider.id.uuid,
      }).then(() => response);
    })
    .then(response => {
      if (typeof window === 'object') {
        const transaction = response.data.data;
        trackIntercomEvent('Custom offer accepted (invoice)', {
          transactionId: transaction.id.uuid,
          processName: transaction.attributes.processName,
          providerId: transaction.relationships.provider.data.id.uuid,
          customerId: transaction.relationships.customer.data.id.uuid,
          transition: 'TRANSITION_ACCEPT_CUSTOM_OFFER_INVOICE',
          listingType: 'service',
          listingId: transaction.relationships.listing.data.id.uuid,
        });
      }
      return response;
    })
    .catch(e => {
      return withGateCode(e).then(err => {
        dispatch(acceptOfferInvoiceError(err));
        log.error(e, 'accept-offer-invoice-failed', {
          txId: id.uuid,
          transition: TRANSITION_ACCEPT_CUSTOM_OFFER_INVOICE,
        });
        throw e;
      });
    });
};

// Plain (non-privileged) transitions on the invoice branch. Each mirrors the
// pro-process thunk of the same shape: transition, mark the other party
// unread, refresh entities and notifications.
const invoiceBranchTransition = (transition, recipientRole) => id => async (
  dispatch,
  getState,
  sdk
) => {
  dispatch(checkJobAsCompletedRequest());

  return sdk.transactions
    .transition(
      { id, transition, params: {} },
      { expand: true, include: ['customer', 'provider', 'listing'] }
    )
    .then(async response => {
      const transaction = response.data.data;
      const recipient = transaction.relationships[recipientRole].data;
      await markTxUnread({
        transactionId: transaction.id.uuid,
        recipientId: recipient.id.uuid,
      });
      dispatch(addMarketplaceEntities(response));
      dispatch(checkJobAsCompletedSuccess());
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      dispatch(checkJobAsCompletedError(storableError(e)));
      log.error(e, 'invoice-branch-transition-failed', { txId: id.uuid, transition });
      throw e;
    });
};

// Provider: work is done, customer should check it.
export const jobDoneInvoice = invoiceBranchTransition(TRANSITION_JOB_DONE_INVOICE, 'customer');
// Customer: accepts the finished work; arrives at state/delivered.
export const acceptJobInvoice = invoiceBranchTransition(TRANSITION_ACCEPT_JOB_INVOICE, 'provider');
// Customer shortcut: done and accepted in one step; arrives at state/delivered.
export const jobDoneAcceptInvoice = invoiceBranchTransition(
  TRANSITION_JOB_DONE_ACCEPT_INVOICE,
  'provider'
);

// Rates and cases for the pending offer, as the server will apply them.
// Fetched when the offer modal opens and after a billing save (spec §5).
//
// Responses can land out of order: the panel's card-path fetch (on mount /
// lastTransition change) can resolve after the modal's invoice-path fetch,
// since the first VIES lookup for a business customer can take seconds
// (R41). Each call gets the next sequence number; the reducer only applies a
// SUCCESS/ERROR whose seq is still the latest one requested, so a late,
// superseded response cannot clobber a newer in-flight request's state.
export const fetchVatPreview = (txId, paymentMethod) => (dispatch, getState) => {
  const seq = getState().TransactionPage.vatPreviewSeq + 1;
  dispatch({ type: FETCH_VAT_PREVIEW_REQUEST, payload: { seq } });
  return vatPreviewApi({
    transactionId: txId.uuid || txId,
    ...(paymentMethod ? { paymentMethod } : {}),
  })
    .then(result => {
      dispatch({ type: FETCH_VAT_PREVIEW_SUCCESS, payload: { seq, preview: result } });
      return result;
    })
    .catch(e => {
      dispatch({
        type: FETCH_VAT_PREVIEW_ERROR,
        payload: { seq, error: storableError(e) },
        error: true,
      });
      throw e;
    });
};

const fetchMessages = (txId, page) => (dispatch, getState, sdk) => {
  const paging = { page, per_page: MESSAGES_PAGE_SIZE };
  dispatch(fetchMessagesRequest());

  return sdk.messages
    .query({
      transaction_id: txId,
      include: [
        'sender',
        'sender.profileImage',
        'publicFileAttachments',
        'publicFileAttachments.file',
      ],
      ...IMAGE_VARIANTS,
      ...paging,
    })
    .then(response => {
      const messages = denormalisedResponseEntities(response);
      const { totalItems, totalPages, page: fetchedPage } = response.data.meta;
      const pagination = { totalItems, totalPages, page: fetchedPage };
      const totalMessages = getState().TransactionPage.totalMessages;
      const txUuid = txId && txId.uuid ? txId.uuid : txId;

      // Original fetchMessages call succeeded
      dispatch(fetchMessagesSuccess(messages, pagination, txUuid));

      // Check if totalItems has changed between fetched pagination pages
      // if totalItems has changed, fetch first page again to include new incoming messages.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.
      if (totalItems > totalMessages && page > 1) {
        dispatch(fetchMessages(txId, 1))
          .then(() => {
            // Original fetch was enough as a response for user action,
            // this just includes new incoming messages
          })
          .catch(() => {
            // Background update, no need to to do anything atm.
          });
      }
    })
    .catch(e => {
      dispatch(fetchMessagesError(storableError(e)));
      throw e;
    });
};

export const fetchMoreMessages = txId => (dispatch, getState, sdk) => {
  const state = getState();
  const { oldestMessagePageFetched, totalMessagePages } = state.TransactionPage;
  const hasMoreOldMessages = totalMessagePages > oldestMessagePageFetched;

  // In case there're no more old pages left we default to fetching the current cursor position
  const nextPage = hasMoreOldMessages ? oldestMessagePageFetched + 1 : oldestMessagePageFetched;

  return dispatch(fetchMessages(txId, nextPage));
};

export const sendMessage = (txId, message, fileIds = []) => (dispatch, getState, sdk) => {
  const { currentUser } = getState().user;

  dispatch(sendMessageRequest());

  // Once the message is out, the files it carried leave the composer.
  const finishSend = () => {
    dispatch(clearStagedAttachments(SCOPE_TRANSACTION_PAGE));
    dispatch(sendMessageSuccess());
  };

  return sdk.messages
    .send(
      { transactionId: txId, content: message, ...publicFileAttachmentsMaybe(fileIds) },
      { expand: true }
    )
    .then(response => {
      const messageId = response.data.data.id;
      const messageData = response.data.data;

      // We fetch the first page again to add sent message to the page data
      // and update possible incoming messages too.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.
      return dispatch(fetchMessages(txId, 1))
        .then(() => {
          if (fileIds.length > 0) {
            // Fire and forget: resolve "scanning" attachment states without a manual refresh.
            dispatch(pollForAttachmentScan(txId));
          }
          return sdk.transactions.show(
            { id: txId, include: ['customer', 'provider'] },
            { expand: true }
          );
        })
        .then(response => {
          const transaction = response.data.data;
          const transactionId = transaction.id;
          const customer = transaction.relationships.customer.data;
          const provider = transaction.relationships.provider.data;
          const isCustomer = currentUser.id.uuid === customer.id.uuid;
          const recipientId = isCustomer ? provider.id : customer.id;

          // Send the message to the created transaction
          return markTxUnread({
            transactionId: transactionId.uuid,
            recipientId: recipientId.uuid,
            message: messageData,
          });
        })
        .then(() => {
          finishSend();
          return messageId;
        })
        .catch(() => finishSend());
    })
    .catch(e => {
      dispatch(sendMessageError(storableError(e)));
      // Rethrow so the page can track whether the sending failed, and
      // keep the message in the form for a retry.
      throw e;
    });
};

// Download a message attachment. The signed storage URL carries
// `Content-Disposition: attachment`, so navigating to it in the same tab
// downloads the file for every type without leaving the page. Same-tab
// navigation is used (instead of window.open) because it's never blocked by
// popup blockers, unlike opening a new tab after this async SDK roundtrip.
// Inline viewing is the preview tile's flow (openAttachment).
export const downloadAttachment = (fileAttachmentId, fileName) => (dispatch, getState, sdk) => {
  dispatch(downloadAttachmentRequest(fileAttachmentId));

  return sdk.fileDownloads
    .create({ fileAttachmentId: new UUID(fileAttachmentId) })
    .then(response => {
      const { url } = response.data.data.attributes;
      if (typeof window !== 'undefined') {
        window.location.assign(url);
      }
      dispatch(downloadAttachmentSuccess(fileAttachmentId));
    })
    .catch(e => {
      log.error(e, 'download-message-attachment-failed', { fileAttachmentId });
      dispatch(downloadAttachmentError(fileAttachmentId, storableError(e)));
    });
};

// Milliseconds to keep a generated blob object URL alive before revoking it.
const ATTACHMENT_BLOB_TTL_MS = 60000;

// Open a message attachment inline (preview tile click). Browser-openable
// files (PDFs, images) are fetched and opened as a blob URL in a new tab: the
// signed storage URL itself carries `Content-Disposition: attachment`, so
// opening it directly would force a download. Anything else, and any failure,
// falls back to the direct download.
export const openAttachment = (fileAttachmentId, fileName) => (dispatch, getState, sdk) => {
  dispatch(downloadAttachmentRequest(fileAttachmentId));

  const openable = isBrowserOpenable(fileName);
  // Open the tab synchronously (inside the click gesture) so it is not blocked
  // as a popup once the async fetch resolves.
  const inlineWindow = openable && typeof window !== 'undefined' ? window.open('', '_blank') : null;

  const openDirect = url => {
    if (inlineWindow) {
      inlineWindow.location.href = url;
    } else if (typeof window !== 'undefined') {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return sdk.fileDownloads
    .create({ fileAttachmentId: new UUID(fileAttachmentId) })
    .then(response => {
      const { url } = response.data.data.attributes;

      if (!openable) {
        openDirect(url);
        dispatch(downloadAttachmentSuccess(fileAttachmentId));
        return undefined;
      }

      return fetch(url)
        .then(res => {
          if (!res.ok) {
            throw new Error(`Attachment fetch failed (status ${res.status})`);
          }
          return res.blob();
        })
        .then(blob => {
          const hasUsableType = blob.type && blob.type !== 'application/octet-stream';
          const renderType = hasUsableType ? blob.type : mimeTypeForFileName(fileName);
          // SECURITY: only render types we trust to be inert (PDF, raster images).
          // A file with an openable extension can still be served as active content
          // (text/html, image/svg+xml); opening that as a blob URL would run script
          // on our origin. Anything not on the allowlist falls back to a download.
          if (!isInlineRenderableMimeType(renderType)) {
            openDirect(url);
            dispatch(downloadAttachmentSuccess(fileAttachmentId));
            return;
          }
          const typedBlob = new Blob([blob], { type: renderType });
          const objectUrl = URL.createObjectURL(typedBlob);
          if (inlineWindow) {
            inlineWindow.location.href = objectUrl;
          } else if (typeof window !== 'undefined') {
            window.open(objectUrl, '_blank', 'noopener,noreferrer');
          }
          setTimeout(() => URL.revokeObjectURL(objectUrl), ATTACHMENT_BLOB_TTL_MS);
          dispatch(downloadAttachmentSuccess(fileAttachmentId));
        })
        .catch(() => {
          // If the inline fetch fails, fall back to a plain download so the user
          // still gets the file.
          openDirect(url);
          dispatch(downloadAttachmentSuccess(fileAttachmentId));
        });
    })
    .catch(e => {
      if (inlineWindow) {
        inlineWindow.close();
      }
      log.error(e, 'open-message-attachment-failed', { fileAttachmentId });
      dispatch(downloadAttachmentError(fileAttachmentId, storableError(e)));
    });
};

// Resolve a short-lived signed URL for an image attachment's preview tile.
// Cached in state so feed re-renders (message polling) don't repeat
// fileDownloads.create calls; `force` bypasses the cache after the previous
// URL expired. Failures only log — the tile just doesn't render, the
// download chip still works.
export const fetchAttachmentPreviewUrl = (fileAttachmentId, options = {}) => (
  dispatch,
  getState,
  sdk
) => {
  const {
    attachmentPreviewUrls: cachedUrls,
    attachmentPreviewUrlPendingIds: pendingIds,
  } = getState().TransactionPage;
  const cached = !!cachedUrls[fileAttachmentId];
  const pending = pendingIds.includes(fileAttachmentId);
  if (pending || (cached && !options.force)) {
    return Promise.resolve();
  }

  dispatch(fetchAttachmentPreviewUrlRequest(fileAttachmentId));
  return sdk.fileDownloads
    .create({ fileAttachmentId: new UUID(fileAttachmentId) })
    .then(response => {
      dispatch(
        fetchAttachmentPreviewUrlSuccess(fileAttachmentId, response.data.data.attributes.url)
      );
    })
    .catch(e => {
      log.error(e, 'fetch-attachment-preview-url-failed', { fileAttachmentId });
      dispatch(fetchAttachmentPreviewUrlError(fileAttachmentId));
    });
};

// Delay before each re-fetch while a scan is pending. Backs off from a few
// seconds to a minute so fast scans resolve quickly while long ones (large
// files / scanner under load) are still caught. Cumulative window ≈ 3 min,
// after which we stop and fall back to a manual refresh. Exported for tests.
export const ATTACHMENT_SCAN_POLL_DELAYS_MS = [3000, 5000, 8000, 12000, 20000, 30000, 45000, 60000];

// A message attachment counts as pending until Sharetribe has resolved its scan
// one way or the other. This must match what ActivityFeed renders as the
// "scanning" chip (anything not available / verificationFailed): a file whose
// storage upload has completed can still be reported as `pendingUpload` for a
// few seconds before the backend flips it to `pendingVerification`, so a message
// sent right after the upload comes back in that state. Deleted files are never
// rendered, so they are not waited on either.
export const isAttachmentPending = attachment => {
  const file = attachment && attachment.file;
  if (!file || file.attributes.deleted) {
    return false;
  }
  const { state } = file.attributes;
  return state !== 'available' && state !== 'verificationFailed';
};

// While an attachment is still being scanned, re-fetch the newest messages so the
// sender's "scanning" chips resolve to downloadable files without a manual refresh.
// The poll stops as soon as no file is pending (scan finished or failed), so each
// dispatch is a cheap no-op when there is nothing to wait for. Recipients never see
// scanning states: Sharetribe delivers the message to them only after the scan has
// completed. Dispatched after sending a message and on page load (see loadData), so
// a reload mid-scan resolves too.
export const pollForAttachmentScan = (txId, attempt = 0) => (dispatch, getState) => {
  const txUuid = txId.uuid || txId;
  const isActiveTx = () => getState().TransactionPage.activeMessagesTxId === txUuid;
  const hasPendingFiles = () =>
    getState().TransactionPage.messages.some(m =>
      (m.publicFileAttachments || []).some(isAttachmentPending)
    );

  const attemptsLeft = attempt < ATTACHMENT_SCAN_POLL_DELAYS_MS.length;
  if (typeof window === 'undefined' || !attemptsLeft || !isActiveTx() || !hasPendingFiles()) {
    return Promise.resolve();
  }

  return new Promise(resolve =>
    window.setTimeout(resolve, ATTACHMENT_SCAN_POLL_DELAYS_MS[attempt])
  ).then(() => {
    if (!isActiveTx()) {
      return null;
    }
    return dispatch(fetchMessages(txId, 1))
      .then(() => dispatch(pollForAttachmentScan(txId, attempt + 1)))
      .catch(() => null);
  });
};

// The offer's counterpart of pollForAttachmentScan: while any of the
// transaction's protected attachments is still being scanned, re-fetch the
// transaction so the offer modal's "scanning" cards turn into download cards
// without a reload. Same back-off schedule; stops when nothing is pending, the
// attempts run out, or the user has navigated to another transaction.
export const pollForOfferAttachmentScan = (txId, txRole, attempt = 0) => (dispatch, getState) => {
  const txUuid = txId.uuid || txId;
  const isActiveTx = () => getState().TransactionPage.activeMessagesTxId === txUuid;
  const currentTransaction = () => {
    const [tx] = denormalisedEntities(
      getState().marketplaceData.entities,
      [{ id: new UUID(txUuid), type: 'transaction' }],
      false
    );
    return tx;
  };
  const hasPendingFiles = () => offerAttachments(currentTransaction()).some(isAttachmentPending);

  const attemptsLeft = attempt < ATTACHMENT_SCAN_POLL_DELAYS_MS.length;
  if (typeof window === 'undefined' || !attemptsLeft || !isActiveTx() || !hasPendingFiles()) {
    return Promise.resolve();
  }

  return new Promise(resolve =>
    window.setTimeout(resolve, ATTACHMENT_SCAN_POLL_DELAYS_MS[attempt])
  ).then(() => {
    if (!isActiveTx()) {
      return null;
    }
    return Promise.resolve(dispatch(fetchTransaction(new UUID(txUuid), txRole)))
      .then(() => dispatch(pollForOfferAttachmentScan(txId, txRole, attempt + 1)))
      .catch(() => null);
  });
};

const REVIEW_TX_INCLUDES = ['reviews', 'reviews.author', 'reviews.subject', 'customer', 'provider'];
const IMAGE_VARIANTS = {
  'fields.image': [
    // Profile images
    'variants.square-small',
    'variants.square-small2x',

    // Listing images:
    'variants.landscape-crop',
    'variants.landscape-crop2x',
  ],
};

// If other party has already sent a review, we need to make transition to
// TRANSITION_REVIEW_2_BY_<CUSTOMER/PROVIDER>
const sendReviewAsSecond = (id, params, role, dispatch, sdk) => {
  const transition = getReview2Transition(role === CUSTOMER);

  const include = REVIEW_TX_INCLUDES;

  return sdk.transactions
    .transition({ id, transition, params }, { expand: true, include, ...IMAGE_VARIANTS })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(sendReviewSuccess());
      return response;
    })
    .then(response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const customer = transaction.relationships.customer.data;
      const provider = transaction.relationships.provider.data;
      const isCustomer = role === CUSTOMER;
      const recipientId = isCustomer ? provider.id : customer.id;

      // Send the message to the created transaction
      return markTxUnread({
        transactionId: transactionId.uuid,
        recipientId: recipientId.uuid,
      }).then(() => {
        return response;
      });
    })
    .catch(e => {
      dispatch(sendReviewError(storableError(e)));

      // Rethrow so the page can track whether the sending failed, and
      // keep the message in the form for a retry.
      throw e;
    });
};

// If other party has not yet sent a review, we need to make transition to
// TRANSITION_REVIEW_1_BY_<CUSTOMER/PROVIDER>
// However, the other party might have made the review after previous data synch point.
// So, error is likely to happen and then we must try another state transition
// by calling sendReviewAsSecond().
const sendReviewAsFirst = (id, params, role, dispatch, sdk) => {
  const transition = getReview1Transition(role === CUSTOMER);
  const include = REVIEW_TX_INCLUDES;

  return sdk.transactions
    .transition({ id, transition, params }, { expand: true, include, ...IMAGE_VARIANTS })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(sendReviewSuccess());
      dispatch(
        fetchOwnReviewSuccess({ content: params.reviewContent, rating: params.reviewRating })
      );
      return response;
    })
    .then(response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const customer = transaction.relationships.customer.data;
      const provider = transaction.relationships.provider.data;
      const isCustomer = role === CUSTOMER;
      const recipientId = isCustomer ? provider.id : customer.id;

      // Send the message to the created transaction
      return markTxUnread({
        transactionId: transactionId.uuid,
        recipientId: recipientId.uuid,
      }).then(() => {
        return response;
      });
    })
    .catch(e => {
      // If transaction transition is invalid, lets try another endpoint.
      if (isTransactionsTransitionInvalidTransition(e)) {
        return sendReviewAsSecond(id, params, role, dispatch, sdk);
      } else {
        dispatch(sendReviewError(storableError(e)));

        // Rethrow so the page can track whether the sending failed, and
        // keep the message in the form for a retry.
        throw e;
      }
    });
};

export const sendReview = (role, tx, reviewRating, reviewContent) => (dispatch, getState, sdk) => {
  const params = { reviewRating, reviewContent };

  const txStateOtherPartyFirst = txIsInFirstReviewBy(tx, role !== CUSTOMER);

  dispatch(sendReviewRequest());

  return txStateOtherPartyFirst
    ? sendReviewAsSecond(tx.id, params, role, dispatch, sdk)
    : sendReviewAsFirst(tx.id, params, role, dispatch, sdk);
};

const isNonEmpty = value => {
  return typeof value === 'object' || Array.isArray(value) ? !isEmpty(value) : !!value;
};

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

const fetchTimeSlots = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchTimeSlotsRequest);

  // Time slots can be fetched for 90 days at a time,
  // for at most 180 days from now. If max number of bookable
  // day exceeds 90, a second request is made.

  const maxTimeSlots = 90;
  // booking range: today + bookable days -1
  const bookingRange = config.dayCountAvailableForBooking - 1;
  const timeSlotsRange = Math.min(bookingRange, maxTimeSlots);

  const start = moment
    .utc()
    .startOf('day')
    .toDate();
  const end = moment()
    .utc()
    .startOf('day')
    .add(timeSlotsRange, 'days')
    .toDate();
  const params = { listingId, start, end };

  return dispatch(timeSlotsRequest(params))
    .then(timeSlots => {
      const secondRequest = bookingRange > maxTimeSlots;

      if (secondRequest) {
        const secondRange = Math.min(maxTimeSlots, bookingRange - maxTimeSlots);
        const secondParams = {
          listingId,
          start: end,
          end: moment(end)
            .add(secondRange, 'days')
            .toDate(),
        };

        return dispatch(timeSlotsRequest(secondParams)).then(secondBatch => {
          const combined = timeSlots.concat(secondBatch);
          dispatch(fetchTimeSlotsSuccess(combined));
        });
      } else {
        dispatch(fetchTimeSlotsSuccess(timeSlots));
      }
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(storableError(e)));
    });
};

export const fetchNextTransitions = id => (dispatch, getState, sdk) => {
  dispatch(fetchTransitionsRequest());

  return sdk.processTransitions
    .query({ transactionId: id })
    .then(res => {
      dispatch(fetchTransitionsSuccess(res.data.data));
    })
    .catch(e => {
      dispatch(fetchTransitionsError(storableError(e)));
    });
};

export const fetchTransactionLineItems = ({ bookingData, listingId, isOwnListing }) => dispatch => {
  dispatch(fetchLineItemsRequest());
  transactionLineItems({ bookingData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        bookingData: bookingData,
      });
    });
};

export const sendProjectBid = (
  listingId,
  transactionId,
  description,
  amount,
  intl,
  deliveryDate
) => (dispatch, getState, sdk) => {
  dispatch(sendProjectBidRequest());

  const bodyParams = {
    id: transactionId,
    transition: TRANSITION_MAKE_PROJECT_BID_AFTER_ENQUIRY,
    params: {
      listingId,
      protectedData: {
        projectBidAmount: amount,
        projectBidDescription: description,
        projectBidDeliveryDate: stringifyDateToISO8601(deliveryDate.date),
      },
    },
  };

  return projectTransitionPrivileged({
    isSpeculative: false,
    bookingData: { description, amount },
    bodyParams,
    queryParams: { expand: true, include: ['provider', 'customer', 'listing'] },
  })
    .then(response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const provider = transaction.relationships.provider.data;

      // Send the message to the created transaction
      return markTxUnread({
        transactionId: transactionId.uuid,
        recipientId: provider.id.uuid,
      }).then(() => {
        return response;
      });
    })
    .then(response => {
      dispatch(sendProjectBidSuccess());
      dispatch(fetchCurrentUserHasOrdersSuccess(true));
      dispatch(fetchTransaction(transactionId, 'customer'));

      return response;
    })
    .then(response => {
      if (typeof window === 'object') {
        trackIntercomEvent('New project bid', {
          transactionId: response.data.data.id.uuid,
          processName: response.data.data.attributes.processName,
          providerId: response.data.data.relationships.customer.data.id.uuid,
          customerId: response.data.data.relationships.provider.data.id.uuid,
          transition: 'TRANSITION_MAKE_PROJECT_BID_AFTER_ENQUIRY',
          listingType: 'project',
          listingId: response.data.data.relationships.listing.data.id.uuid,
        });
      }
      return response.data.data.id;
    })
    .catch(e => {
      dispatch(sendProjectBidError(storableError(e)));
      throw e;
    });
};

export const declineProjectBid = id => (dispatch, getState, sdk) => {
  if (declineProjectBidInProgress(getState())) {
    return Promise.reject(new Error('Project bid decline already in progress'));
  }
  dispatch(declineProjectBidRequest());

  return sdk.transactions
    .transition(
      { id, transition: TRANSITION_DECLINE_OFFER, params: {} },
      { expand: true, include: ['customer'] }
    )
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(declineProjectBidSuccess());
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .then(response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const customer = transaction.relationships.customer.data;

      // Mark project transaction as read
      return markTxRead(transactionId.uuid, customer.id.uuid).then(() => {
        return response;
      });
    })
    .catch(e => {
      dispatch(declineProjectBidError(storableError(e)));
      log.error(e, 'reject-project-bid-failed', {
        txId: id,
        transition: TRANSITION_DECLINE_OFFER,
      });
      throw e;
    });
};

export const showProfileListing = userId => (dispatch, getState, sdk) => {
  dispatch(showProfileListingRequest());

  return sdk.listings
    .query({
      authorId: userId,
      pub_listingType: 'profile',
      include: ['author'],
    })
    .then(response => {
      const listings = response.data.data || [];

      if (listings.length >= 1) {
        dispatch(showProfileListingSuccess(listings[0]));
      } else {
        throw new Error('Provider does not have a profile listing created.');
      }

      return denormalisedResponseEntities(response)[0];
    })
    .catch(e => {
      dispatch(showProfileListingError(storableError(e)));
      console.error(e);
    });
};

export const sendEnquiryCustomer = (listingId, isLightEntrepreneur, message) => (
  dispatch,
  getState,
  sdk
) => {
  dispatch(sendEnquiryRequest());

  // Every enquiry starts on default or light; invoicing is a branch inside
  // those processes (spec 2026-09-22), so the customer's flags play no part.
  const processAlias = isLightEntrepreneur ? config.lightProcessAlias : config.bookingProcessAlias;
  const bodyParams = {
    transition: TRANSITION_ENQUIRE,
    processAlias: processAlias,

    params: { listingId },
  };
  return sdk.transactions
    .initiate(bodyParams, { expand: true, include: ['provider'] })
    .then(response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const provider = transaction.relationships.provider.data;
      const recipientId = provider.id;

      return sdk.messages
        .send({ transactionId, content: message }, { expand: true })
        .then(response => {
          const messageData = response.data.data;
          // Send the message to the created transaction
          return markTxUnread({
            transactionId: transactionId.uuid,
            recipientId: recipientId.uuid,
            message: messageData,
          });
        })
        .then(() => {
          dispatch(sendEnquirySuccess());
          dispatch(fetchCurrentUserHasOrdersSuccess(true));

          return transactionId;
        });
    })
    .catch(e => {
      dispatch(sendEnquiryError(storableError(e)));
      throw e;
    });
};

export const sendEnquiryProvider = (listingId, message) => (dispatch, getState, sdk) => {
  dispatch(sendEnquiryRequest());
  const bodyParams = {
    transition: TRANSITION_ENQUIRE,
    processAlias: config.projectProcessAlias,
    params: { listingId },
  };
  return sdk.transactions
    .initiate(bodyParams, { expand: true, include: ['provider'] })
    .then(response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const provider = transaction.relationships.provider.data;
      const recipientId = provider.id;

      return sdk.messages
        .send({ transactionId, content: message }, { expand: true })
        .then(response => {
          const messageData = response.data.data;
          // Send the message to the created transaction
          return markTxUnread({
            transactionId: transactionId.uuid,
            recipientId: recipientId.uuid,
            message: messageData,
          });
        })
        .then(() => {
          dispatch(sendEnquirySuccess());
          dispatch(fetchCurrentUserHasOrdersSuccess(true));

          return transactionId;
        });
    })
    .catch(e => {
      dispatch(sendEnquiryError(storableError(e)));
      throw e;
    });
};

export const jobDoneReleaseFunds = id => (dispatch, getState, sdk) => {
  dispatch(jobDoneReleaseFundsRequest());

  const payoutInvoiceDate = new Date();

  return sdk.transactions
    .transition(
      {
        id,
        transition: TRANSITION_JOB_DONE_RELEASE_FUNDS,
        params: {
          protectedData: {
            payoutInvoiceDate: {
              year: payoutInvoiceDate.getFullYear(),
              month: payoutInvoiceDate.getMonth() + 1,
              day: payoutInvoiceDate.getDate(),
              hours: 0,
              minutes: 0,
              seconds: 0,
              milliseconds: 0,
            },
          },
        },
      },
      { expand: true, include: ['provider', 'customer', 'listing'] }
    )
    .then(response => {
      const tx = response.data.data;
      const { protectedData = {} } = tx.attributes;
      const { lePayoutTransactionId } = protectedData;

      dispatch(addMarketplaceEntities(response));
      dispatch(jobDoneReleaseFundsSuccess());
      dispatch(fetchCurrentUserNotifications());

      if (lePayoutTransactionId) {
        completePayoutTransaction(lePayoutTransactionId).then(() => {
          return sdk.transactions
            .transition(
              {
                id: new UUID(lePayoutTransactionId),
                transition: TRANSITION_RELEASE_FUNDS,
                params: {},
              },
              { expand: true }
            )
            .then(() => {
              return response;
            });
        });
      }

      return response;
    })
    .then(response => {
      const transaction = response.data.data;
      const transactionId = transaction.id;
      const provider = transaction.relationships.provider.data;

      // Send the message to the created transaction
      return markTxUnread({
        transactionId: transactionId.uuid,
        recipientId: provider.id.uuid,
      }).then(() => {
        return response;
      });
    })
    .then(response => {
      if (typeof window === 'object') {
        trackIntercomEvent('Job done funds released', {
          transactionId: response.data.data.id.uuid,
          processName: response.data.data.attributes.processName,
          providerId: response.data.data.relationships.provider.data.id.uuid,
          customerId: response.data.data.relationships.customer.data.id.uuid,
          transition: 'TRANSITION_JOB_DONE_RELEASE_FUNDS',
          listingType: response.data.data.attributes.protectedData.projectTransactionId
            ? 'project'
            : 'service',
          listingId: response.data.data.relationships.listing.data.id.uuid,
        });
      }
      return response;
    })
    .catch(e => {
      dispatch(releaseFundsError(storableError(e)));
      log.error(e, 'job-done-release-funds failed', {
        txId: id,
        transition: TRANSITION_JOB_DONE_RELEASE_FUNDS,
      });
      throw e;
    });
};

// loadData is a collection of async calls that need to be made
// before page has all the info it needs to render itself
export const loadData = params => async (dispatch, getState) => {
  const txId = new UUID(params.id);
  const currentUser = await dispatch(fetchCurrentUser());
  const currentUserId = currentUser && currentUser.id ? currentUser.id.uuid : '0';
  const state = getState().TransactionPage;
  const txRef = state.transactionRef;
  const txRole = params.transactionRole;

  // In case a transaction reference is found from a previous
  // data load -> clear the state. Otherwise keep the non-null
  // and non-empty values which may have been set from a previous page.
  const initialValues = txRef ? {} : pickBy(state, isNonEmpty);
  // Always record the conversation being loaded so the message reducer can discard
  // late responses from a previously viewed conversation.
  dispatch(setInitialValues({ ...initialValues, activeMessagesTxId: txId.uuid }));

  // Fetch skills and tools if not already loaded
  const skillsAndToolsState = getState().SkillsAndTools;
  const fetchSkillsAndToolsIfNeeded = async () => {
    if (
      skillsAndToolsState.skillOptions.length === 0 ||
      skillsAndToolsState.toolOptions.length === 0
    ) {
      await dispatch(fetchSkillsAndTools());
    }
  };

  // Note: provider Stripe Connect account state is used by
  // ProviderOnboardingRequiredModal to gate conversation access. We don't
  // fetch it explicitly here — fetchCurrentUser (above) already includes the
  // stripeAccount relationship and dispatches stripeAccountCreateSuccess when
  // present (see user.duck.js), which populates state.stripeConnectAccount.
  // Dispatching fetchStripeAccount() for users without an account would
  // otherwise store a spurious error in redux that StripePayoutPage would
  // then surface to the user.

  return markTxRead(params.id, currentUserId).then(res => {
    // Sale / order (i.e. transaction entity in API)
    return Promise.all([
      dispatch(fetchCurrentUserNotifications()),
      dispatch(fetchTransaction(txId, txRole)),
      dispatch(fetchMessages(txId, 1)),
      dispatch(fetchNextTransitions(txId)),
      fetchSkillsAndToolsIfNeeded(),
    ]).then(results => {
      // Messages are now in state; resolve any lingering "scanning" chips (e.g. the
      // sender reloaded while a file is still being scanned) without a second manual
      // refresh. Fire-and-forget: a no-op on the server and when nothing is pending.
      dispatch(pollForAttachmentScan(txId));
      dispatch(pollForOfferAttachmentScan(txId, txRole));
      return results;
    });
  });
};

// Save a PDF the server just generated (downloadable receipts spec §7): a
// temporary <a download> on an object URL, revoked once the browser has it.
const saveBlob = (blob, fileName) => {
  if (typeof window === 'undefined') return;
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(url), ATTACHMENT_BLOB_TTL_MS);
};

// Download this party's receipt or billing basis. The server builds it on
// every request (a few seconds); only the transaction ids go into state.
export const downloadReceipt = ({ transactionId, kind, locale }) => dispatch => {
  dispatch(downloadReceiptRequest(transactionId));
  return downloadTransactionReceipt({ transactionId, locale })
    .then(blob => {
      saveBlob(blob, receiptFilename(kind, transactionId, locale));
      dispatch(downloadReceiptSuccess(transactionId));
    })
    .catch(e => {
      log.error(e, 'download-receipt-failed', { transactionId, kind });
      dispatch(downloadReceiptError(transactionId));
    });
};
